import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { dataURItoFile } from '../helpers/avatar-util';
var updateUserAvatar = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_, args, context) {
    var userId, fileURI, url, fileObject, formData, fetchOptions;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          userId = args.userId, fileURI = args.fileURI;
          url = "".concat(context.url.stargateRoot, "/users/").concat(userId, "/manage/avatar");
          fileObject = dataURItoFile(fileURI);
          formData = new FormData();
          formData.append('file', fileObject);
          fetchOptions = {
            method: 'PUT',
            body: formData,
            headers: {
              'Content-Type': undefined
            }
          };
          return _context.abrupt("return", context
          // @ts-ignore: we want to not pass 'Content-Type' header explicitly
          .fetch(url, fetchOptions)
          // Although current API in id-public-api-facade does not return new uploaded avatar,
          // we still want to have it in client-side
          .then(function () {
            return {
              url: fileURI
            };
          }));
        case 7:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function updateUserAvatar(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
export default updateUserAvatar;